import { TRootState } from 'store/store';

export const getUser = (state: TRootState) => state.user;
